import styled from 'styled-components';
import tw from 'twin.macro';

export const Section = styled.section`
  padding: 3rem 0;
  background-color: #dfe2ca;
`;

export const Container = styled.div`
  max-width: 1140px;
  margin: 0 auto;
`;

export const Row = styled.div`
  ${tw`flex flex-wrap items-center`}
`;

export const Column = styled.div`
    ${tw`w-full md:w-1/2 mb-4 md:mb-0`}
`;

export const Image = styled.img`
    ${tw`w-auto  h-auto md:h-[650px] rounded shadow-sm sm:ml-5`}
  
`;

export const Title = styled.h2`
    ${tw`mb-4 pb-3 border-b border-black`}
`;

export const Text = styled.p`
  ${tw`mb-4 text-lg`}
`;

export const StyledLink = styled.a`
  ${tw`tracking-wide no-underline text-black font-bold border-black pb-2 relative inline-block`}

  &:hover {
    transform: translateX(5px);
  }

  &::after {
    content: '';
    position: absolute;
    height: 2px;
    background-color: #000;
    width: 0;
    bottom: 0;
    left: 0;
    transition: width 0.3s ease-in-out;
  }

  &:hover::after {
    width: 100%;
  }
`;
